import { render } from "./TabInformationsOpportunity.vue?vue&type=template&id=286595ec"
import script from "./TabInformationsOpportunity.vue?vue&type=script&lang=js"
export * from "./TabInformationsOpportunity.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__